module.exports = __webpack_public_path__ + "static/media/heart_icon.f3ec94d2.svg";